import React from 'react'

import List from '../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'

const DIVISIONS = {
  1: 'Law',
  2: 'Fire',
  3: 'EMS',
}
const divisionIdToName = (id) => DIVISIONS[id] || 'NONE'

const IncidentTypeList = () => {
  const columns = [
    { header: 'Id', value: (item) => item.id },
    { header: 'Name', value: (item) => item.name, isLink: true },
    { header: 'Code', value: (item) => item.code },
    { header: 'Division', value: (item) => divisionIdToName(item.divisionId) },
  ]
  return (
    <List
      title="Incident Types"
      routeName={ROUTE_NAME}
      apiUrl={API_URL}
      columns={columns}
    />
  )
}

export default IncidentTypeList
